var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccountUploadSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#EAEBEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18.19H25.61C23.24 18.19 21.31 16.26 21.31 13.89V11C21.31 10.45 20.86 10 20.31 10H16.07C12.99 10 10.5 12 10.5 15.57V24.43C10.5 28 12.99 30 16.07 30H23.93C27.01 30 29.5 28 29.5 24.43V19.19C29.5 18.64 29.05 18.19 28.5 18.19Z",
    fill: "#46515A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7997 10.2105C23.3897 9.80048 22.6797 10.0805 22.6797 10.6505V14.1405C22.6797 15.6005 23.9197 16.8105 25.4297 16.8105C26.3797 16.8205 27.6997 16.8205 28.8297 16.8205C29.3997 16.8205 29.6997 16.1505 29.2997 15.7505C27.8597 14.3005 25.2797 11.6905 23.7997 10.2105Z",
    fill: "#46515A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountUploadSuccess);
export default __webpack_public_path__ + "static/media/ic_account_upload_success.c758dd5c9ae8b28ba97a753b1beeaa58.svg";
export { ForwardRef as ReactComponent };